import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'admin-panel',
    loadChildren: () =>
      import('./pages/admin-panel/admin-panel.routes').then((m) => m.routes),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'not-verified',
    loadComponent: () =>
      import('./pages/not-verified/not-verified.component').then(
        (m) => m.NotVerifiedComponent
      ),
  },
  {
    path: '**',
    redirectTo: '/auth',
  },
];
